<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
              <!--SID1038 Body Part -->
							<template>
								<el-container class="SID1011__UserGroupRegistration">
									<div class="SID1011__Container">
									<!-- Breadcrumb section -->
									<el-breadcrumb separator-class="el-icon-arrow-right">
										<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
										<el-breadcrumb-item :to="{ path: '1010' }">ユーザーグループ一覧</el-breadcrumb-item>
										<el-breadcrumb-item :to="{ path: '' }">ユーザーグループ登録</el-breadcrumb-item>
									</el-breadcrumb>
										<div class="registerDiv">
											<el-form ref="form" :model="form" :rules="rules" label-width="auto" class="div-form ">
													<el-form-item label="ユーザーグループID" prop="usergroupid">
														<el-input v-model="form.usergroupid" ></el-input>
													</el-form-item>
													<el-form-item label="契約サービス毎の閲覧可否" prop="contractService">		
														<el-checkbox-group  v-model="form.contractService" @change="ChangeNews">
															<el-checkbox label="1" :disabled="newsArticle">新聞</el-checkbox>															
															<el-checkbox label="3" :disabled="magazineArticle">雑誌</el-checkbox>															
															<el-checkbox label="2" :disabled="webNewsArticle">WEBニュース</el-checkbox>	
														</el-checkbox-group>																											
													</el-form-item>
													<el-form-item label="記事の全件選択を可能とする">
														<el-checkbox-group v-model="form.selectionArticles">
															<el-checkbox label="1" :disabled="newsArticle">新聞</el-checkbox>															
															<el-checkbox label="3" :disabled="magazineArticle">雑誌</el-checkbox>															
															<el-checkbox label="2" :disabled="webNewsArticle">WEBニュース</el-checkbox>
														</el-checkbox-group>
														
													</el-form-item>
													<el-row class="checkbox_groupcss">
														<el-form-item label="全媒体の媒体毎窓のサイズ">										
															<span class="padding-spancss">新聞</span>	
															<span class="padding-spancss">雑誌</span>	
															<span>WEBニュース</span>																																												
														</el-form-item>	
													</el-row>															
													<el-row class="checkbox_groupcss">												
													<el-form-item label="" prop="radio">
														<el-col :span="7" >
														<el-radio-group v-model="form.radio" :disabled="newsArticleDisable == 0">	
														<el-radio :label="3">小</el-radio>
														<el-radio :label="2">中</el-radio>
														<el-radio :label="1">大</el-radio>														
														</el-radio-group>
														</el-col>
														<el-col :span="6">
														<el-radio-group v-model="form.radio_magazine" :disabled="magazineArticleDisable == 0">
														<el-radio :label="3">小</el-radio>
														<el-radio :label="2">中</el-radio>
														<el-radio :label="1">大</el-radio>
														</el-radio-group>
														</el-col>
														<el-col :span="6">
														<el-radio-group v-model="form.radio_web" :disabled="webNewsArticleDisable == 0">
														<el-radio :label="3">小</el-radio>
														<el-radio :label="2">中</el-radio>
														<el-radio :label="1">大</el-radio>
														</el-radio-group>
														</el-col>
													</el-form-item>
													</el-row>																																																													
													<el-form-item label="テーマグループを展開して表示する">
														<el-switch v-model="value3" class="inputSwitch"></el-switch>
													</el-form-item>
													<el-form-item v-if="is_MC_User_Authority"  label="MC原文利用上限" prop="eltextusageLimit">
														<el-input  v-model="form.eltextusageLimit" ></el-input>														
													</el-form-item>
													<el-form-item v-else label="MC原文利用上限" prop="eltextusageLimit_nonreq">
														<el-input  v-model="form.eltextusageLimit_nonreq" :disabled="is_MC_User_Authority == false"></el-input>														
													</el-form-item>
													<el-form-item v-if="is_SC_User_Authority" label="SC原文利用上限" prop="sctextusagelimit">	
														<el-input  v-model="form.sctextusagelimit" ></el-input>
													</el-form-item>
													<el-form-item v-else label="SC原文利用上限" prop="sctextusagelimit_nonreq">	
														<el-input  v-model="form.sctextusagelimit_nonreq" :disabled="is_SC_User_Authority == false" ></el-input>
													</el-form-item>
													<el-form-item label="原文利用実績照会を表示する">
														<el-switch v-model="value4"  class="inputSwitch"></el-switch>
													</el-form-item>													
													<el-form-item label="原文利用請求ID" prop="mctextusagelimit">									
														<el-input v-model="form.mctextusagelimit" ></el-input>																		
													</el-form-item>
													<el-form-item>
														<el-button @click="onSubmit('form')" type="primary" plain>登録</el-button>
														<el-button  type="info" @click="gotoback" plain class="buttonReturn1011">戻る</el-button>
													</el-form-item>              
												</el-form>            
										</div> 
									
									</div>
								</el-container>
							</template>
              <!--SID1038 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>
			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/vue/2.5.17/vue.js"></script>
<script>

import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from '../../router';
import json from '../../components/config.json';
import config from '../../common/CommonConst.json';
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import Vue from 'vue'
export default {
	name: "app",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		
		var confirmLengthMC = (rule, value, callback) => {
			var passCheck = this.form.eltextusageLimit;
			if( this.is_MC_User_Authority == false){
				passCheck = this.form.eltextusageLimit_nonreq;
			}
			if (passCheck.length > 5) {
				callback(new Error("MC length"));
			} else {
				callback();
			}
		};

		var confirmLengthSC = (rule, value, callback) => {
			var passCheck = this.form.sctextusagelimit;
			if( this.is_SC_User_Authority == false){
				passCheck = this.form.sctextusagelimit_nonreq;
			}
			if (passCheck.length > 5) {
				callback(new Error("SC Length"));
			} else {
				callback();
			}
		};

			
			var checkID = (rule, value, callback) => {
              
			var passw= /^(?=.*[/])(?=.*[!@#$%^&*])[-!@#$%^&*]$/;
			
            if (value.match(passw)) {
              callback(new Error('原文利用請求IDは記号以外を入力してください。'));
            } 
           else {
                callback();
            }
	};
	var confirmEmail = (rules, value, callback) => {
		var sympattern= /^[a-zA-Z0-9]+$/
		var regex = /[\u3040-\u309F]|[\u30A0-\u30FF]/g;
        var chksym= value;
		if(regex.test(chksym)){
            callback(new Error("原文利用請求IDは半角英数字を入力してください。"));
        }
		else if (!chksym.match(sympattern)) {
			callback(new Error('原文利用請求IDは記号以外を入力してください。'));
		}else{
			callback();
		}
    };
		return {
			useridfrom1010:'',
			newsArticle: true,
			magazineArticle: true,
			webNewsArticle: true,
			addNew: 1,
			webNewsArticleDisable: 0,
			magazineArticleDisable: 0,
			newsArticleDisable: 0,
			is_MC_User_Authority: false,
			is_SC_User_Authority: false,
			form: {
				radio:'',
				radio_web:'',
				radio_magazine:'',
				eltextusageLimit:'',
				sctextusagelimit:'',
				sctextusagelimit_nonreq:'',
				eltextusageLimit_nonreq:'',
				groupname:'',
				usergroupid:'',
				mctextusagelimit:'',
				contractService:["1","2","3"],
				selectionArticles:["1","2","3"],
				radio:'3',
				radio_web:'3',
				radio_magazine:'3'


            },
            inputVisible: false,
			value1: false,
			value2: false,
			value3: true,
			value4: true,			
			isEdit: false,
			rules: {
             usergroupid:[
				{ required: true, message: 'ユーザーグループIDを入力してください。 ' },
				{max: 20, message:'ユーザーグループID*は20文字以下を入力してください。'},
				{ 
					pattern:/^[\uff66-\uff9fa-zA-Z0-9"!#$%&'()*+,-.:;<=>?@[\]\/^_`{|}~]*$/ ,
					message:'ユーザーグループIDは半角英数字を入力してください。'
				}
			], 
			groupname:[
				{ required: true, message: 'ユーザーグループ名を入力してください。 ' },
				{ max:20 , message: 'ユーザグループ名 は20文字以下で入力してください。' }
				
			], 
			eltextusageLimit:[
				{ required: true, message: 'MC原文利用上限＊を入力してください。' },
				{ pattern:/^^[0-9]+$/, message: 'MC原文利用上限＊は半角数字を入力してください。'},
				{ validator:confirmLengthMC, message:'MC原文利用上限＊は0～99999以外の値を入力できません。'}
			], 
			sctextusagelimit:[
				{ required: true, message: 'SC原文利用上限＊を入力してください。'},
				{ pattern:/^^[0-9]+$/, message: 'SC原文利用上限＊は半角数字を入力してください。'},
				{ validator:confirmLengthSC, message:'SC原文利用上限＊は0～99999以外の値を入力できません。'}
				
            ], 
			eltextusageLimit_nonreq:[
				{ pattern:/^^[0-9]+$/, message: 'MC原文利用上限＊は半角数字を入力してください。'},
				{ validator:confirmLengthMC, message:'MC原文利用上限＊は0～99999以外の値を入力できません。'}
			], 
			sctextusagelimit_nonreq:[
				{ pattern:/^^[0-9]+$/, message: 'SC原文利用上限＊は半角数字を入力してください。'},
				{ validator:confirmLengthSC, message:'SC原文利用上限＊は0～99999以外の値を入力できません。'}
            ], 
			mctextusagelimit:[
				{ 
					max:9, message: '原文利用請求IDは9文字以下を入力してください。'
				},
				{ pattern:/^[/a-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,. @]+$/,message:'原文利用請求IDは半角英数字を入力してください。'},
				/*** Change by BM for backlog Id: 1643 removed "/" from the pattern*/
				{ pattern:/^[\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9]+$/,message:'原文利用請求IDは記号以外を入力してください。'}
			], 
			contractService: [
				{ required: true, message: '契約サービス毎の閲覧可否は1つ以上を選択してください。', trigger: 'change' }
            ],	
			}
        };
	},
	
	computed: {
		...mapGetters("situation1011", [
			"getinputVisible",
			"getvalue1",
			"getvalue2",
			"getvalue3",
			"getvalue4",
			"getgroupname1011",
			"getusergroupid1011",
			"geteltextusageLimit1011",
			"getmctextusagelimit1011",
			"getsctextusagelimit1011",
			"getcheck",
			"getactivename",
			"getstatus",
			"getmsgdetail"
		]),
		...mapGetters("situation0001", [
			"getServiceLinkageInfo"
		])
	},
     methods: {
		filterInput(e){
      e.target.value = e.target.value.replace(/[^0-9]+/g, '');
	},
	ChangeNews(val){
		// for disable / enable the Window Media for News and web
		var val_len = val.length;

		this.newsArticleDisable= 0;
		this.webNewsArticleDisable= 0;
		this.magazineArticleDisable=0;
		if (val_len > 0) {
			for (var j = 0; j < val_len; j++) {
			if (val[j] == 1&&this.newsService) {
          this.newsArticleDisable=1
			}
			if (val[j] == 2&&this.webService) {
          this.webNewsArticleDisable=1
			}
			if (val[j] == 3&&this.magazineService) {
          this.magazineArticleDisable=1
			}
			}
		}else{
			this.newsArticleDisable= 0;
			this.webNewsArticleDisable= 0;
			this.magazineArticleDisable= 0;

		} 

		

	},
		onSubmit(formName) {
			this.$LogButtonEvent("1011","Register");
			this.$LogMethodIN("1010","onSubmit");
			this.$refs[formName].validate((valid) => {
			if (valid)
			{
	
				var contract_service_browsability1 = false;
				var contract_service_browsability2 = false;
				var contract_service_browsability3 = false;

				if(this.form.contractService.indexOf("1") !== -1){
					contract_service_browsability1 = true;
				}

				if(this.form.contractService.indexOf("2") !== -1){
					contract_service_browsability2 = true;
				}

				if(this.form.contractService.indexOf("3") !== -1){
					contract_service_browsability3 = true;
				}

				

				var all_articles_selectable_flag1 = false;
				var all_articles_selectable_flag2 = false;
				var all_articles_selectable_flag3 = false;
				if(this.form.selectionArticles.indexOf("1") !== -1){
					all_articles_selectable_flag1 = true;
				}

				if(this.form.selectionArticles.indexOf("2") !== -1){
					all_articles_selectable_flag2 = true;
				}

				if(this.form.selectionArticles.indexOf("3") !== -1){
					all_articles_selectable_flag3 = true;
				}

				var status;
				if(this.isEdit == false){

					var Add_From_SID1011_AID0035 = {
						contract_id:config['contract_id'],
						user_group_name:this.form.usergroupid,
						subtheme_display_flag:this.value3,
						pdf_usage_display_flag:this.value4,
						demand_id:this.form.mctextusagelimit, 
						process_kbn:1,
						data_section:[]
					};

					var use_max_count1_val = 0;
					// 2021/02/19 #10515 START
					//if( this.form.eltextusageLimit != "" || this.form.eltextusageLimit_nonreq != ""){
					if( this.form.eltextusageLimit !== "" || this.form.eltextusageLimit_nonreq !== ""){
					// 2021/02/19 #10515 END
						use_max_count1_val  = this.is_MC_User_Authority == true ? this.form.eltextusageLimit : this.form.eltextusageLimit_nonreq;
					}
					// While Registration
					/*** Changes by SJ for backlog Id: 1754 */
					else{
						use_max_count1_val = "";
					}
					var use_max_count2_val = 0;
					// 2021/02/19 #10515 START
					//if( this.form.sctextusagelimit != "" || this.form.sctextusagelimit_nonreq != ""){
					if( this.form.sctextusagelimit !== "" || this.form.sctextusagelimit_nonreq !== ""){
					// 2021/02/19 #10515 END
						use_max_count2_val  = this.is_SC_User_Authority == true ? this.form.sctextusagelimit : this.form.sctextusagelimit_nonreq;
					}
					/*** Changes by SJ for backlog Id: 1754 */
					else{
						use_max_count2_val  = "";
					}

					if(this.newsArticle == false)
					{
						Add_From_SID1011_AID0035.contract_service_browsability1 = contract_service_browsability1;
						Add_From_SID1011_AID0035.all_articles_selectable_flag1 = all_articles_selectable_flag1;
						Add_From_SID1011_AID0035.media_window_size1 = this.form.radio;
						Add_From_SID1011_AID0035.use_max_count1 = parseInt(use_max_count1_val);
						Add_From_SID1011_AID0035.use_max_count2 = parseInt(use_max_count2_val);
						//Backlog bug fix 1464
						if(this.is_MC_User_Authority && (this.form.eltextusageLimit >= 0|| this.form.eltextusageLimit_nonreq >= 0)){
							Add_From_SID1011_AID0035.data_section.push(1);
						}
						else if(this.form.eltextusageLimit >= 0|| this.form.eltextusageLimit_nonreq >= 0){
							Add_From_SID1011_AID0035.data_section.push(1);
						}

						if(this.is_SC_User_Authority && (this.form.sctextusagelimit >= 0|| this.form.sctextusagelimit_nonreq >= 0)){
							Add_From_SID1011_AID0035.data_section.push(2);
						}
						else if(this.form.sctextusagelimit >= 0|| this.form.sctextusagelimit_nonreq >= 0){
							Add_From_SID1011_AID0035.data_section.push(2);
						}
					}

					if(this.magazineArticle == false)
					{
						Add_From_SID1011_AID0035.contract_service_browsability3 = contract_service_browsability3;
						Add_From_SID1011_AID0035.all_articles_selectable_flag3 = all_articles_selectable_flag3;
						Add_From_SID1011_AID0035.media_window_size3 = this.form.radio_magazine;
						Add_From_SID1011_AID0035.data_section.push(5);
					}

					if(this.webNewsArticle == false)
					{
						Add_From_SID1011_AID0035.contract_service_browsability2 = contract_service_browsability2;
						Add_From_SID1011_AID0035.all_articles_selectable_flag2 = all_articles_selectable_flag2;
						Add_From_SID1011_AID0035.media_window_size2 = this.form.radio_web;
						Add_From_SID1011_AID0035.data_section.push(3);
					}

					this.$store.dispatch('communication1011/AddFormData_1011',Add_From_SID1011_AID0035)
					.then(() => {
						//After the Ajax call finished check if status is error for showing alert
						var status = this.getstatus;
						var msgdetail = this.getmsgdetail;
						if(status == "0")
						{
							this.$alert(msgdetail, json["1011_register_success_title"], {	confirmButtonText: 'OK'})
							.then(() => {
								router.push({ name: "1010"})
							});
						}
						else if(status == "1")
						{
							this.$alert(msgdetail, json["1011_register_failed_title"] , {	confirmButtonText: 'OK'})
						}
					})
					.catch((error) => { 
						console.log(error);
						this.$alert(json["1011_register_failed_message"], json["1011_register_failed_title"], {	confirmButtonText: 'OK'	});
					});

				}
				else
				{
					var Edit_From_1011_AID0035 = {
						contract_id:config['contract_id'],
						user_group_id:this.useridfrom1010,
						user_group_name:this.form.usergroupid,
						subtheme_display_flag:this.value3,
						pdf_usage_display_flag:this.value4,
						demand_id:this.form.mctextusagelimit, 
						process_kbn:2,
						data_section:[]
					};

					use_max_count1_val = 0;
					// 2021/02/19 #10515 START
					//if( this.form.eltextusageLimit != "" || this.form.eltextusageLimit_nonreq != ""){
					if( this.form.eltextusageLimit !== "" || this.form.eltextusageLimit_nonreq !== ""){
					// 2021/02/19 #10515 END
						use_max_count1_val  = this.is_MC_User_Authority == true ? this.form.eltextusageLimit : this.form.eltextusageLimit_nonreq;
					}
					// While Updating
					/*** Changes by SJ for backlog Id: 1754 */
					else{
						use_max_count1_val = "";
					}
					use_max_count2_val = 0;
					// 2021/02/19 #10515 START
					//if( this.form.sctextusagelimit != "" || this.form.sctextusagelimit_nonreq != ""){
					if( this.form.sctextusagelimit !== "" || this.form.sctextusagelimit_nonreq !== ""){
					// 2021/02/19 #10515 END
						use_max_count2_val  = this.is_SC_User_Authority == true ? this.form.sctextusagelimit : this.form.sctextusagelimit_nonreq;
					}
					/*** Changes by SJ for backlog Id: 1754 */
					else{
						use_max_count2_val = "";
					}

					if(this.newsArticle == false)
					{
						Edit_From_1011_AID0035.contract_service_browsability1 = contract_service_browsability1;
						Edit_From_1011_AID0035.all_articles_selectable_flag1 = all_articles_selectable_flag1;
						Edit_From_1011_AID0035.media_window_size1 = this.form.radio;
						Edit_From_1011_AID0035.use_max_count1 = parseInt(use_max_count1_val);
						Edit_From_1011_AID0035.use_max_count2 = parseInt(use_max_count2_val);
						//Backlog bug fix 1464
						if(this.is_MC_User_Authority && (this.form.eltextusageLimit >= 0|| this.form.eltextusageLimit_nonreq >= 0)){
							Edit_From_1011_AID0035.data_section.push(1);
						}
						else if(this.form.eltextusageLimit >= 0|| this.form.eltextusageLimit_nonreq >= 0){
							Edit_From_1011_AID0035.data_section.push(1);
						}
						if(this.is_SC_User_Authority && (this.form.sctextusagelimit >= 0|| this.form.sctextusagelimit_nonreq >= 0)){
							Edit_From_1011_AID0035.data_section.push(2);
						}
						else if(this.form.sctextusagelimit >= 0|| this.form.sctextusagelimit_nonreq >= 0){
							Edit_From_1011_AID0035.data_section.push(2);
						}
					}

					if(this.magazineArticle == false)
					{
						Edit_From_1011_AID0035.contract_service_browsability3 = contract_service_browsability3;
						Edit_From_1011_AID0035.all_articles_selectable_flag3 = all_articles_selectable_flag3;
						Edit_From_1011_AID0035.media_window_size3 = this.form.radio_magazine;
						Edit_From_1011_AID0035.data_section.push(5);
					}

					if(this.webNewsArticle == false)
					{
						Edit_From_1011_AID0035.contract_service_browsability2 = contract_service_browsability2;
						Edit_From_1011_AID0035.all_articles_selectable_flag2 = all_articles_selectable_flag2;
						Edit_From_1011_AID0035.media_window_size2 = this.form.radio_web;
						Edit_From_1011_AID0035.data_section.push(3);
					}
					

					this.$store.dispatch('communication1011/EditFormData_1011',Edit_From_1011_AID0035)
					.then(() => {
						//After the Ajax call finished check if status is error for showing alert
						var status = this.getstatus;
						var msgdetail = this.getmsgdetail;
						if(status == "0")
						{
							this.$alert(msgdetail, json["1011_Update_success_title"], {	confirmButtonText: 'OK'})
							.then(() => {
								router.push({ name: "1010"})
							});
							
						}
						else if(status == "1")
						{
							this.$alert(msgdetail, json["1011_Update_success_title"] , {	confirmButtonText: 'OK'})
						}
					})
					.catch((error) => { 
						console.log(error);
						this.$alert(json["1011_Update_failed_message"], json["1011_Update_failed_title"], {	confirmButtonText: 'OK'	});
					});
					
				}

			}
			else
			{
				return false;
			}
			});
			this.$LogMethodOut("1011","onSubmit");
		},
		gotoback(){
			this.$LogButtonEvent("1011","Return");
			this.$LogMethodIN("1010","gotoback");
			router.push({name:"1010"});
			this.$LogMethodOut("1011","gotoback");
		}  
	},
	created : function(){
		
	},
	mounted(){
		var service_linkage = this.getServiceLinkageInfo; 
	
		if(service_linkage.length > 0){
			var service_linake_check = [];
			for(var l=0;l<service_linkage.length;l++){

				var data_section = service_linkage[l].data_section;
				
				if(data_section == "1" || data_section == "2"){
          this.newsService=true
          if(this.$route.params.response&&this.$route.params.response[0].contract_service_browsability1){
            this.newsArticleDisable=1
          }
					this.newsArticle = false;
					this.form.radio = 2;
					if(service_linake_check.indexOf("1") == -1)
					{
						service_linake_check.push("1");
					}
				}
				if(data_section == "5"){
          this.magazineService=true
          if(this.$route.params.response&&this.$route.params.response[0].contract_service_browsability3){
            this.magazineArticleDisable=1
          }
					this.magazineArticle = false;
					this.form.radio_magazine = 2;
					if(service_linake_check.indexOf("3") == -1)
					{
						service_linake_check.push("3");
					}
				}
				if(data_section == "3"){
          this.webService=true
          if(this.$route.params.response&&this.$route.params.response[0].contract_service_browsability2){
            this.webNewsArticleDisable=1
          }
					this.webNewsArticle = false;
					this.form.radio_web = 2;
					if(service_linake_check.indexOf("2") == -1)
					{
						service_linake_check.push("2");
					}
				}

				if(data_section == "1"){
					this.is_MC_User_Authority = true;
				}

				if(data_section == "2"){
					this.is_SC_User_Authority = true;
				}
			}
			// this.form.contractService = service_linake_check;
			// this.form.selectionArticles = service_linake_check;
		}

		if(this.$route.params.response)
		{
			this.addNew=0;
			this.isEdit=true;	
			for(var i=0;i<this.$route.params.response.length;i++){

				this.useridfrom1010 = this.$route.params.response[i].user_group_id;
				this.form.usergroupid =this.$route.params.response[i].user_group_name;
				if( this.is_MC_User_Authority == true){
					this.form.eltextusageLimit = this.$route.params.response[i].use_max_count1;
				}
				// While Editing Get the data
				/*** Changes by SJ for backlog Id: 1754 */
				else if(this.is_MC_User_Authority == false && this.$route.params.response[i].use_max_count1 == 0){
					this.form.eltextusageLimit = "";
				}
				else{
					this.form.eltextusageLimit_nonreq = this.$route.params.response[i].use_max_count1;
				}
				
				if( this.is_SC_User_Authority == true){
					this.form.sctextusagelimit = this.$route.params.response[i].use_max_count2;
				}
				/*** Changes by SJ for backlog Id: 1754 */
				else if(this.is_SC_User_Authority == false && this.$route.params.response[i].use_max_count2 == 0){
					this.form.sctextusagelimit = "";
				}
				else{
					this.form.sctextusagelimit_nonreq = this.$route.params.response[i].use_max_count2;
				}
				
				this.form.mctextusagelimit = this.$route.params.response[i].demand_id;
				this.value3 = this.$route.params.response[i].subtheme_display_flag,
				this.value4 = this.$route.params.response[i].pdf_usage_display_flag,
				this.form.usergroupname =this.$route.params.response[i].user_group_name;
				this.form.radio	=this.$route.params.response[i].media_window_size1;
				this.form.radio_web	=this.$route.params.response[i].media_window_size2;
				this.form.radio_magazine =this.$route.params.response[i].media_window_size3;
				

				var contract_service_browsability = []
				if(this.$route.params.response[i].contract_service_browsability1 == true){
					contract_service_browsability.push("1")
				}
				if(this.$route.params.response[i].contract_service_browsability2 == true){
					contract_service_browsability.push("2")
				}
				if(this.$route.params.response[i].contract_service_browsability3 == true){
					contract_service_browsability.push("3")
				}
				this.form.contractService = contract_service_browsability;


				var all_articles_selectable_flag = [];
				if(this.$route.params.response[i].all_articles_selectable_flag1 == true)
				{
					all_articles_selectable_flag.push("1")
				}

				if(this.$route.params.response[i].all_articles_selectable_flag2 == true)
				{
					all_articles_selectable_flag.push("2")
				}

				if(this.$route.params.response[i].all_articles_selectable_flag3 == true)
				{
					all_articles_selectable_flag.push("3")
				}

				this.form.selectionArticles = all_articles_selectable_flag;

			}

		}else{
      this.newsArticleDisable=1
      this.magazineArticleDisable=1
      this.webNewsArticleDisable=1
    }

	},
	beforeCreate(){
	//For the screen Title
     document.title = "ユーザーグループ一覧画面";
	},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1011.css";
</style>